import { GET } from 'utils/requests.utils'

const BASE_URL = (username) => `/shop/${username}/products`

export const fetchList = (data) => GET(BASE_URL(data.username), data)

export const fetchItem = (slug, data) => GET(`${BASE_URL(data.username)}/${slug}`, data)
